export { default } from './AdobeTargetMove';